import { useParams } from 'react-router-dom'

import { useLlmoAnalysisDetailApi } from '@/common/api/modules/llmo'
import { ShareOfVoiceHistoryDetailResponse } from '@/common/api/params/llmo'
import { MediaAnalysisType } from '@/common/model/media/mediaAnalysis'

import ShareOfVoiceResultView from '@/components/container/modules/mediaGeo/shareOfVoice/ShareOfVoiceResultView'

import MediaAnalysisResultPageBase from './MediaAnalysisResultPageBase'

// シェア・オブ・ボイス分析結果（GEO/LLMO）
const MediaAnalysisShareOfVoiceResultPage = () => {
  const { siteId, historyId } = useParams()
  const sid = Number(siteId)
  // 分析中（status=analyzing）の間は2秒間隔でポーリングし、完了したら自動的に停止する
  const { data, error } = useLlmoAnalysisDetailApi<ShareOfVoiceHistoryDetailResponse>(
    siteId && historyId ? { site_id: sid, history_id: Number(historyId) } : undefined,
    { refreshInterval: (latest) => (latest?.status === 'analyzing' ? 2000 : 0) }
  )

  return (
    <MediaAnalysisResultPageBase
      type={MediaAnalysisType.SHARE_OF_VOICE}
      data={data}
      error={error}
      resultError={data?.result?.error}
    >
      {data?.result && <ShareOfVoiceResultView result={data.result} />}
    </MediaAnalysisResultPageBase>
  )
}

export default MediaAnalysisShareOfVoiceResultPage
